import Popover from '@components/Popover'
import POIMarkerImage from 'map/components/popover/POIMarkerImage'
import styles from './styles.module.scss'

const PinPopover = ({ name, id, image }) => (
    <Popover
        className={styles.poi}
        renderTitle={() => (
            <div>
                <POIMarkerImage image={image} />
                <span>{name}</span>
            </div>
        )}
        renderContent={() => (
            <div className={styles.poiContent}>
                <Link to={`/place-of-interest/${id}`}>
                    <T>map.label.readmore</T>
                </Link>
            </div>
        )}
    />
)

export default PinPopover
